// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__EBVfO","asideWrapper":"Aside_asideWrapper__Ufl04"};